<template>
    <div>
        <div
            :id="addressModalId"
            class="modal fade"
            tabindex="-1"
            role="dialog"
            style="display: none;"
        >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title font-normal" id="modalTitle">Edit Address</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>

                    <div class="modal-body">
                        <form class="form">

                            <div class="form-group">
                                <label for="address_line_1">Address line 1</label>
                                <input
                                    class="form-control"
                                    :placeholder="inputPlaceholder"
                                    type="text"
                                    id="address_line_1"
                                    name="address_line_1"
                                    v-model="form.address_line_1"
                                    :class="{'is-invalid': form.errors.has('address_line_1')}"
                                />

                                <span class="invalid-feedback" v-show="form.errors.has('address_line_1')">
                                    @{{ form.errors.get("address_line_1") }}
                                </span>
                            </div>

                            <div class="form-group">
                                <label for="address_line_2">Address line 2</label>
                                <input
                                    class="form-control"
                                    :placeholder="inputPlaceholder"
                                    type="text"
                                    id="address_line_2"
                                    name="address_line_2"
                                    v-model="form.address_line_2"
                                    :class="{'is-invalid': form.errors.has('address_line_2')}"
                                />

                                <span class="invalid-feedback" v-show="form.errors.has('address_line_2')">
                                    @{{ form.errors.get("address_line_2") }}
                                </span>
                            </div>

                            <div class="form-group">
                                <label for="address_line_3">Address line 3</label>
                                <input
                                    class="form-control"
                                    :placeholder="inputPlaceholder"
                                    type="text"
                                    id="address_line_3"
                                    name="address_line_3"
                                    v-model="form.address_line_3"
                                    :class="{'is-invalid': form.errors.has('address_line_3')}"
                                />

                                <span class="invalid-feedback" v-show="form.errors.has('address_line_3')">
                                    @{{ form.errors.get("address_line_3") }}
                                </span>
                            </div>

                            <div class="form-group">
                                <label for="city">City</label>
                                <input
                                    class="form-control"
                                    :placeholder="inputPlaceholder"
                                    type="text"
                                    id="city"
                                    name="city"
                                    v-model="form.city"
                                    :class="{'is-invalid': form.errors.has('city')}"
                                />

                                <span class="invalid-feedback" v-show="form.errors.has('city')">
                                    @{{ form.errors.get("city") }}
                                </span>
                            </div>

                            <div class="form-group">
                                <label for="state_province_region">State / Province</label>
                                <input
                                    class="form-control"
                                    :placeholder="inputPlaceholder"
                                    type="text"
                                    id="state_province_region"
                                    name="state_province_region"
                                    v-model="form.state_province_region"
                                    :class="{'is-invalid': form.errors.has('state_province_region')}"
                                />

                                <span class="invalid-feedback" v-show="form.errors.has('state_province_region')">
                                    @{{ form.errors.get("state_province_region") }}
                                </span>
                            </div>

                            <div class="form-group">
                                <label for="zip_postal_code">Zip / Postal Code</label>
                                <input
                                    class="form-control"
                                    :placeholder="inputPlaceholder"
                                    type="text"
                                    id="zip_postal_code"
                                    name="zip_postal_code"
                                    v-model="form.zip_postal_code"
                                    :class="{'is-invalid': form.errors.has('zip_postal_code')}"
                                />

                                <span class="invalid-feedback" v-show="form.errors.has('zip_postal_code')">
                                    @{{ form.errors.get("zip_postal_code") }}
                                </span>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                         <button
                            class="select-none px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow text-white bg-indigo-600 hover:bg-indigo-700"
                            @click.prevent="update"
                            :disabled="form.busy">
                            {{ form.busy ? "Updating..." : "Update" }}
                        </button>

                        <button
                            type="button"
                            class="btn btn-default waves-effect"
                            data-dismiss="modal"
                            :disabled="form.busy"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ["address", "requireFullAddress"],

    data () {
        return {
            form: new AppForm({
                address_line_1: this.address.address_line_1,
                address_line_2: this.address.address_line_2,
                address_line_3: this.address.address_line_3,
                city: this.address.city,
                state_province_region: this.address.state_province_region,
                zip_postal_code: this.address.zip_postal_code
            })
        };
    },
    computed: {
        addressModalId () {
            return "address-modal-" + this.address.id;
        },
        inputPlaceholder () {
            return this.requireFullAddress ? "Required" : "";
        }
    },
    methods: {
        showAddressModal () {
            $("#address-modal-" + this.address.id).modal("show");
        },
        hideAddressModal () {
            $("#address-modal-" + this.address.id).modal("hide");
        },
        update () {
            if (this.requireFullAddress && this.requireFullAddress === true) {
                let validAddress = this.validateAddress();
                if (!validAddress) {
                    toastr.error("Please complete all the address fields to continue!");
                    return;
                }
            }

            App.patch("/address/" + this.address.id + "/update", this.form)
            .then((response) => {
                toastr.success("Address saved!");
                this.hideAddressModal();
                this.$emit("address-updated", response);
            });
        },
        validateAddress () {
            return !(_.isEmpty(this.form.address_line_1)
                || _.isEmpty(this.form.city)
                || _.isEmpty(this.form.state_province_region)
                || _.isEmpty(this.form.zip_postal_code));
        }
    },
    mounted () {
        let self = this;
        Bus.$on("show-address-modal", function (addressId) {
            if (self.address.id === addressId) {
                self.showAddressModal();
            }
        });
    }
};
</script>
